module.exports = __webpack_public_path__ + "img/base_activites_parapente.bc32560f.svg";